import React from 'react'
import { LightgalleryProvider, LightgalleryItem } from 'react-lightgallery'
import { Image, Section } from 'newComponents'
import 'lightgallery.js/dist/css/lightgallery.css'
import './styles.scss'

const ImageSlice = (props) => {
  const { data } = props
  const { primary } = data
  const { image, lightbox } = primary

  if (lightbox) {
    return (
      <Section className="image-slice">
        <LightgalleryProvider
          lightgallerySettings={{
            counter: false,
            download: false
          }}
        >
          <LightgalleryItem src={image?.url}>
            <Image image={image} />
          </LightgalleryItem>
        </LightgalleryProvider>
      </Section>
    )
  }

  return (
    <Section className="image-slice">
      <Image image={image} />
    </Section>
  )
}

export default ImageSlice
